import { ADD_TO_SONG_LIST, LOAD_SONG_LIST_SUCCESS } from '../actions/songlist';
import { FIRESTORE_SONGLIST_RECEIVED } from '../actions/firestore';

const songs = (state = [], action) => {
  switch (action.type) {
  case ADD_TO_SONG_LIST: {
    return [action.filename, ...state.filter(fn => fn.trim() !== action.filename)];
  }
  case LOAD_SONG_LIST_SUCCESS:
  case FIRESTORE_SONGLIST_RECEIVED: {
    return [...action.songlist];
  }
  default:
    return state;
  }
};

export default songs;



// WEBPACK FOOTER //
// ./src/reducers/songlist.js